import React from "react";
import { Modal } from "../../common/Modal.jsx";
import { PortalTrigger } from "../../common/Portal.jsx";
import { FaIcon } from "../../common/Icons.jsx";

const PhaseInfoDialog = ({ title, info }) => {
    return (
        <Modal title={title} size="m" hideButtons>
            <div style={{whiteSpace: 'pre-line'}}>
                {info}
            </div>
        </Modal>
    );
};

export const PhaseInfoDialogButton = ({ title, info }) => {
    return (
        <PortalTrigger
            label={<FaIcon type="info" />}
            btnProps={{ type: "default", size: "xs", className: "ml-1" }}
            portalProps={{
                component: PhaseInfoDialog,
                title: title,
                info: info,
            }}
        />
    );
};